import { Resources } from 'constants/resources';

import { OrderConversionList } from 'pages/Monitoring/OrderConversion/OrderConversionList/OrderConversionList';
import { ResourceProps } from 'react-admin';

export const orderConversionResource: ResourceProps = {
  name: Resources.OrderConversion,
  create: <></>,
  edit: <></>,
  show: <></>,
  list: OrderConversionList,
};
